import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useGamificationFx } from '@/contexts/GamificationFxContext';
import { usePrefersReducedMotion } from '@/hooks/usePrefersReducedMotion';
import { Modal, Button } from '@/components/ui';
import { LevelBadge } from './LevelBadge';
import { storage } from '@/lib/storage';

export function LevelUpModal() {
  const { t } = useTranslation();
  const fx = useGamificationFx();
  const reducedMotion = usePrefersReducedMotion();
  const reducedFx = storage.get('ember:reducedFx', false);
  const firedRef = useRef(false);

  useEffect(() => {
    if (fx.showingLevelUp && !firedRef.current && !reducedMotion && !reducedFx) {
      firedRef.current = true;
      void import('canvas-confetti').then(({ default: confetti }) => {
        confetti({ particleCount: 80, spread: 70, origin: { y: 0.6 } });
      });
    }
    if (!fx.showingLevelUp) firedRef.current = false;
  }, [fx.showingLevelUp, reducedMotion, reducedFx]);

  if (!fx.showingLevelUp) return null;

  return (
    <Modal
      open
      onOpenChange={(open) => !open && fx.dismissLevelUp()}
      title={t('gamification.levelUp')}
      hideTitle
      size="sm"
    >
      <div className="flex flex-col items-center gap-4 py-4 text-center">
        <LevelBadge level={fx.showingLevelUp.to} size="lg" />
        <div>
          <p className="font-display text-3xl text-parchment-ink">{t('gamification.levelUp')}</p>
          <p className="text-sm text-parchment-muted">
            {t('gamification.youReachedLevel', { level: fx.showingLevelUp.to })}
          </p>
        </div>
        <Button onClick={() => fx.dismissLevelUp()}>{t('common.continue')}</Button>
      </div>
    </Modal>
  );
}
